import { render, staticRenderFns } from "./MetalPricingPlan.vue?vue&type=template&id=d136a552&scoped=true&"
import script from "./MetalPricingPlan.vue?vue&type=script&lang=js&"
export * from "./MetalPricingPlan.vue?vue&type=script&lang=js&"
import style0 from "./MetalPricingPlan.vue?vue&type=style&index=0&id=d136a552&scoped=true&lang=css&"
import style1 from "./MetalPricingPlan.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d136a552",
  null
  
)

export default component.exports